import React from 'react'
import intropic from "../../../assets/pics/intopic.png"
import livedherewordpic from "../../../assets/pics/livedhereword.png"

export default function Places() {
  return (
    <div className='h-fit bg-rd-400'>

        
                <div className='h-[240px] md:h-[480px] relative bg-yelow-400'>
                    <img
                    src={intropic}
                    className='h-full w-full'
                    alt="lived here intro pic"
                    />
                    
                    <img
                    src={livedherewordpic}
                    // className='absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-26 h-5/6 w-2/4'
                    className='absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-26 h-4/6 w-4/6  sm:w-3/4 md:h-5/6 md:w-2/4 lg:h-5/6 lg:w-2/4'
                    alt="lived here word logo"
                    />
                </div>


    </div>
  )
}
